import TileLayer from "ol/layer/Tile";
import XYZ from "ol/source/XYZ";
import * as proj from "ol/proj";
import * as extent from "ol/extent";
import WMTS from "ol/source/WMTS";
import WMTSTileGrid from "ol/tilegrid/WMTS";
import ImageLayer from "ol/layer/Image";
import { ImageArcGISRest } from "ol/source";

//import Elm from "./elm/Themes.elm";

export default class MyPlugin {
  constructor() {
    // this.hooks = {
    //     newMessage : new tapable.SyncHook(['message'])
    // }

    this.message = "message from plug1";
  }

  apply(core) {
    this.core = core;
    core.mapCmd("addLayerCmd", val => {
      console.log(val);
      var map = core.getMap();
      if (map) {
        switch (val.config.type) {
          case "XYZ":
            {
              let lg = [];
              for (var layer of val.config.value.layers) {
                let xyz = new TileLayer({
                  visible: true,
                  preload: 4,
                  zIndex: layer.zIndex || 0,
                  opacity: val.opacity || 1,
                  source: new XYZ({
                    crossOrigin: "anonymous",
                    url: layer.url,
                    maxZoom: 19,
                    minZoom: 1,
                    tileLoadFunction: (imageTile, src) => {
                      imageTile.getImage().src = src;
                    }
                  })
                });
                xyz.set("name", val.name);
                xyz.set("id", val.id);
                lg.push(xyz);
                map.addLayer(xyz);
              }
            }
            break;
          case "WMTS":
            {
              let projection = proj.get("EPSG:3857"),
                projectionExtent = projection.getExtent(),
                size = extent.getWidth(projectionExtent) / 256,
                zooms = 19 + 1,
                resolutions = new Array(zooms),
                matrixIds = new Array(zooms);
              for (let z = 0; z < zooms; ++z) {
                resolutions[z] = size / Math.pow(2, z);
                matrixIds[z] = z;
              }

              for (var layer of val.config.value.layers) {
                layer.useToken = layer.tokenKey != undefined;
                if (layer.useToken) {
                  
                    //TODO: Pull from tokens
                    if (wrap.ags) {
                      if (
                        wrap.ags[layer.tokenKey] &&
                        wrap.ags[layer.tokenKey].baseUrl &&
                        wrap.ags[layer.tokenKey].baseUrl.length
                      ) {
                        layer.url =
                          wrap.ags[layer.tokenKey].baseUrl + layer.url;
                      }
                      
                    }

                    //Fallback because the token key wasnt found
                    
                  
                }
                let wmts = new TileLayer({
                  visible: true,
                  preload: 4,
                  zIndex: layer.zIndex || 0,
                  opacity: val.opacity || 1,
                  source: new WMTS({
                    crossOrigin: layer.crossOrigin || "anonymous",
                    url: layer.url,
                    matrixSet: layer.matrixSet || "webmercator",
                    format: layer.format || "image/png",
                    projection: projection,
                    requestEncoding: layer.requestEncoding || "REST",
                    tileGrid: new WMTSTileGrid({
                      extent: val.config.value.extent, //TODO
                      resolutions: resolutions,
                      matrixIds: matrixIds
                    }),
                    style: layer.style || "default",
                    tileLoadFunction: (imageTile, src) => {
                      imageTile.getImage().src =
                        `${src}` + (layer.token ? `?token=` + layer.token : "");
                    }
                  })
                });
                wmts.set("name", val.name);
                wmts.set("id", val.id);
                map.addLayer(wmts);
              }
            }
            break;
          case "Export":
            {
              //var layer =of val.config.value.layers)
              var base = val.config.value;
              for (var layer of val.config.value.layers);
              {
                //The random adds a random value to the parameter
                //essentually cach busting
                let customParams = {
                  get random() {
                    return Math.random();
                  }
                };

                layer.useToken = layer.tokenKey != undefined;

                if (layer.boundingBox !== undefined) {
                  customParams["BBOX"] = layer.boundingBox;
                }
                if (layer.layerToShow !== undefined) {
                  customParams["LAYERS"] = layer.layerToShow;
                }
                if (base.layerDefs !== undefined) {
                  customParams["LAYERDEFS"] = base.layerDefs;
                }

                if (layer.useToken) {
                  if (layer.tokenKey == undefined) {
                    customParams["token"] = wrap.agsToken;
                  } else {
                    //TODO: Pull from tokens
                    if (wrap.ags) {
                      if (
                        wrap.ags[layer.tokenKey] &&
                        wrap.ags[layer.tokenKey].baseUrl &&
                        wrap.ags[layer.tokenKey].baseUrl.length
                      ) {
                        layer.url =
                          wrap.ags[layer.tokenKey].baseUrl + layer.url;
                      }
                      customParams["token"] = wrap.ags[layer.tokenKey].token;
                    }

                    //Fallback because the token key wasnt found
                    if (!customParams["token"]) {
                      console.log("TOKEN KEY NOT FOUND");
                      customParams["token"] = wrap.agsToken;
                    }
                  }
                }

                let dynamicLayer = new ImageLayer({
                  visible: true,
                  preload: 4,
                  zIndex: layer.zIndex || 0,
                  opacity: val.opacity || 1,
                  source: new ImageArcGISRest({
                    crossOrigin: "anonymous",
                    ratio: 1,
                    params: customParams,
                    url: layer.url,
                    maxZoom: 19,
                    imageLoadFunction: (image, src) => {
                      image.getImage().src = src;
                    }
                  })
                });
                dynamicLayer.set("name", val.name);
                dynamicLayer.set("id", val.id);
                map.addLayer(dynamicLayer);
              }
            }
            break;
          default: {
            console.log(
              "Layer type " + val.config.type + ": has not been implemented"
            );
          }
        }
      }
    });
    // core.hooks.newMessage.tap("LogBox", message => {
    //   this.elm.ports.receiveData.send(message);
    // });
  }

  init() {}

  // _addNewMessage(message){
  //     this.core.newMessage(message);

  // }

  render() {
    const el = document.createElement("div");
    //this.elm = Elm.Themes.embed(el);
    // console.log(this.elm);

    return el;
  }
}
